<template>
    <v-footer class="bg-grey-lighten-4 pa-2" style="max-height: 40px">
        <v-row justify="center" no-gutters>
            <p class="pa-0 ma-0">
                <a class="text-decoration-none text-typography2" href="/privacy"
                    >Privacy Policy</a
                >
            </p>
        </v-row>
    </v-footer>
</template>

<style scoped>
p {
    font-size: 0.75em;
}
</style>
